// Splits a radar axis label across lines of about 15 characters, keeping every word.
//
// Lines, not an ellipsis. "Opening compression" cut to "Opening compre…" is harder to read at a
// glance than the same words split, and a clipped label on a chart about someone's performance
// invites the reader to guess which parameter it is. At most three lines are drawn; a label that
// needs more keeps its remaining words on the third line rather than dropping them.
const LINE = 15;
const MAX_LINES = 3;

export function wrapLabel(label) {
  const text = (label || "").trim();
  if (text.length <= LINE) return [text];
  const words = text.split(/\s+/);
  if (words.length === 1) return [text];
  const lines = [];
  let current = "";
  words.forEach((word) => {
    if (!current) current = word;
    else if ((current + " " + word).length <= LINE) current += " " + word;
    else { lines.push(current); current = word; }
  });
  if (current) lines.push(current);
  if (lines.length <= MAX_LINES) return lines;
  return [...lines.slice(0, MAX_LINES - 1), lines.slice(MAX_LINES - 1).join(" ")];
}
